import {DriveStep} from 'driver.js'
import {PageKey} from '../../@contexts'
import {LoadingState} from '../../../global'
import {Dispatch, SetStateAction, useEffect, useState} from 'react'
import {useDispatch} from 'react-redux'
import {actions} from '../../@reducer/DriverRedux'

interface UseStartDriverProps {
    loading: LoadingState;
    pageFeatureFlag: boolean;
    steps: DriveStep[];
    pageName: PageKey;
    startDriver: (steps: DriveStep[]) => void;
    initialDriverState?: boolean;
}

interface UseStartDriverReturn {
    hasDriverStarted: boolean;
    setHasDriverStarted: Dispatch<SetStateAction<boolean>>;
    error: string | null;
}

const useStartDriver = ({
                            loading,
                            pageFeatureFlag,
                            steps,
                            pageName,
                            startDriver,
                            initialDriverState = false
                        }: UseStartDriverProps): UseStartDriverReturn  => {

    const dispatch = useDispatch();
    const [hasDriverStarted, setHasDriverStarted] = useState(initialDriverState);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (loading === 'fulfilled' && !pageFeatureFlag && !hasDriverStarted) {
            try {
                startDriver(steps);
                // dispatch(actions.markPageAsSeen(pageName));
                setHasDriverStarted(true);
                setError(null);
            } catch (err) {
                setError(err.message || 'Une erreur est survenue lors du démarrage du driver');
            }
        }
    }, [loading, pageFeatureFlag, hasDriverStarted, startDriver, steps, dispatch, pageName]);

    return {
        hasDriverStarted,
        setHasDriverStarted,
        error,
    };
}

export {useStartDriver}